import React, { FC } from 'react'
import { Collapse, CollapseProps } from '@mui/material'

const EvtCollapse: FC<CollapseProps> = ({ children, ...props }) => {
    return <Collapse {...props}>{children}</Collapse>
}

export default EvtCollapse
